import Vue from 'vue';
import pageTable from '../components/common/pagedTable.vue';
import formBuilder from '../components/common/formBuilder.vue';
import siteBranch from '../components/common/siteBranch.vue';
import importBranch from '../components/common/importBranch.vue';
import partner from '../components/partner.vue';
Vue.component('paged-table', pageTable);
Vue.component('form-builder', formBuilder);
Vue.component('site-branch', siteBranch);
Vue.component('partner', partner);
Vue.component('import-branch', importBranch);

